import { Actions, ActionTypes } from './login.actions';
import { Verify2FAError } from '@app/auth/routes/login/state/login.model';

export interface State {
  readonly loginError?: string;
  readonly verify2FAError?: Verify2FAError;
  readonly pending: boolean;
  readonly showPasswordField: boolean;
  readonly attemptsLeft?: number;
  readonly bannedTime?: number;
}

export const initialState: State = {
  pending: false,
  showPasswordField: false,
};

export function reducer(state = initialState, action: Actions): State {
  switch (action.type) {
    case ActionTypes.LOGIN: {
      return {
        ...state,
        loginError: undefined,
        pending: true,
      };
    }

    case ActionTypes.LOGIN_SUCCESS: {
      return {
        ...state,
        loginError: undefined,
        attemptsLeft: undefined,
        bannedTime: undefined,
        pending: false,
      };
    }

    case ActionTypes.LOGIN_FAILURE: {
      return {
        ...state,
        loginError: action.payload.error,
        attemptsLeft: action.payload.attemptsLeft,
        bannedTime: action.payload.bannedTime,
        pending: false,
      };
    }

    case ActionTypes.LOGIN_SHOW_PASSWORD: {
      return {
        ...state,
        showPasswordField: true,
      };
    }

    case ActionTypes.VERIFY_2FA_CODE_FAILURE: {
      return {
        ...state,
        verify2FAError: action.payload,
      };
    }

    default: {
      return state;
    }
  }
}

export const getLoginError = (state: State) => {
  return state.loginError;
};
export const getVerify2FAError = (state: State) => {
  return state.verify2FAError;
};
export const getPending = (state: State) => {
  return state.pending;
};
